__turbopack_context__.v({
  "bar": "Loader-module-scss-module__B0klcG__bar",
  "bar-container": "Loader-module-scss-module__B0klcG__bar-container",
  "container": "Loader-module-scss-module__B0klcG__container",
  "label": "Loader-module-scss-module__B0klcG__label",
});
